export default __webpack_public_path__ + "static/media/IMG_4909.8db48bcc.png";